import { render, staticRenderFns } from "./t-occurrence-risk.vue?vue&type=template&id=74110198&"
import script from "./t-occurrence-risk.vue?vue&type=script&lang=js&"
export * from "./t-occurrence-risk.vue?vue&type=script&lang=js&"
import style0 from "./t-occurrence-risk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports